import React, { useEffect, useRef, useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { CaptableManagementBreadCrumbs } from '../core/_constants'
import { useIntl } from 'react-intl'
// import { Link, useNavigate } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import ScenarioDataCard from '../components/ScenarioDataCard'
// import AddWaterfallScenarioModal from '../components/AddWaterfallScenarioModal'
// import AddFinancialScenarioModal from '../components/AddFinancialScenarioModal'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import brandingConfig from '../../../../config/brandingConfig'
import { useAuth } from '../../auth'
import { getAllScenario } from '../core/_requests'
import NoDataPage from '../../widgets/components/NoDataPage'
import ScenarioDataCardSkeleton from '../components/ScenarioDataCardSkeleton'
// import { Dropdown } from 'react-bootstrap'
// import { useThemeMode } from '../../../../_metronic/partials'

const Scenarios = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  // const { mode } = useThemeMode()

  const [search, setSearch] = useState('')
  const [, setShowKebabMenu] = useState(false)
  const { companyId } = useAuth()
  const [scenario, setScenario] = useState<any>()
  const [scenarioLoading, setScenarioLoading] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const getSenarios = async () => {
    setScenarioLoading(true)
    if (!companyId) return
    try {
      const {
        data: { data, success },
      } = await getAllScenario(companyId, search)
      if (success) {
        setScenario(data)
      }
    } catch (error) {
      console.error('Error fetching convertible security classes:', error)
    } finally {
      setScenarioLoading(false)
    }
  }

  useEffect(() => {
    getSenarios()
  }, [search]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <PageTitle
        breadcrumbs={CaptableManagementBreadCrumbs}
        description={formatMessage({ id: 'Scenarios' })}
      >
        {formatMessage({ id: 'Cap Table Management' })}
      </PageTitle>
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'}  ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}
      >
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100`}
              onClick={() => {
                localStorage.removeItem('formFields')
                localStorage.removeItem('selectedToggles')
                navigate('../scenarios/create-new-scenario')
              }}
            >
              {formatMessage({ id: 'Create New Scenario' })}
            </button>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end px-4 px-md-0'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white mb-4 font-weight-400 w-100`}
              onClick={() => navigate('../scenarios/create-new-scenario')}
            >
              {formatMessage({ id: 'Create New Scenario' })}
            </button>
          </div>
        </div>
      </div>
      <div className='d-md-flex justify-content-between align-items-center px-6'>
        <h1 className='fs-4 fs-4'>{formatMessage({ id: 'Scenarios' })}</h1>
        <div className='d-flex gap-2 align-items-center justify-content-md-end justify-content-between mb-4'>
          <div className='d-flex align-items-center w-100'>
            <span className='svg-icon svg-icon-3 position-absolute ms-2'>
              <img src={searchIcon} alt='Search icon' />
            </span>
            <input
              type='text'
              data-kt-inbox-listing-filter='search'
              className='bg-body bg-white form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 py-3 border '
              placeholder='Search Scenario'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className='px-6'>
        <div className='w-100'>
          <InfoCard2
            title={formatMessage({ id: 'How to Manage Your Cap Table Efficiently?' })}
            desc={formatMessage({
              id: `${brandingConfig.brandName}’s Cap Table Management feature offers a seamless and organized approach to track your equity, project future ownership scenarios, and analyze management events.`,
            })}
            slug={brandingConfig.helpLinks.captableManagementDashboardOverview}
            className='w-100 mb-0'
          />
        </div>
        <div className='container-fluid p-0 m-0'>
          {scenarioLoading ? (
            <div className="row">
              {Array(6).fill(null).map((_, index) => (
                <div className='col-12 col-md-6 col-lg-4 mb-4' key={index}>
                  <ScenarioDataCardSkeleton />
                </div>
              ))}
            </div>
          ) : scenario && scenario.scenarios.length > 0 ? (
            <div className='row'>
              {scenario.scenarios.map((singleScenario: any, index: any) => (
                <div className='col-12 col-md-6 col-lg-4 mb-4' key={index}>
                  <ScenarioDataCard
                    scenarioDetails={singleScenario}
                    currentValuation={scenario.currentValuation}
                    getSenarios={getSenarios}
                  />
                </div>
              ))}
            </div>
          ) : (
            <NoDataPage />
          )}
          {/* {!scenario || scenario.scenarios.length === 0 ?
            <NoDataPage />
            :
            scenarioLoading ?
              <div className="row">
                {Array(6).fill(null).map((_, index) => (
                  <div className='col-12 col-md-6 col-lg-4 mb-4' key={index}>
                    <ScenarioDataCardSkeleton />
                  </div>
                ))}
              </div>
              :
              <div className='row'>
                {scenario.scenarios.map((singleScenario: any, index: any) => (
                  <div className='col-12 col-md-6 col-lg-4 mb-4' key={index}>
                    <ScenarioDataCard
                      scenarioDetails={singleScenario}
                      currentValuation={scenario.currentValuation}
                      getSenarios={getSenarios}
                    />
                  </div>
                ))}
              </div>
          } */}
        </div>
      </div>
    </>
  )
}

export default Scenarios
